module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_1-3.f35d2234.svg";